import dayjs from 'dayjs';

const convertNumberToSeconds = (value: number) => {
  return dayjs().startOf('day').add(value, 'second').format('HH:mm:ss');
};

export default convertNumberToSeconds;
